import { Button, Grid } from "@mui/material";
import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";

interface Category {
  id: number;
  title: string;
  icon: string;
  SettlementPercentage: number;
}

interface StoreCardProps {
  arrayCategory: Category;
  setChildeValueCategory: any;
  setUpdatePercentage: any;
}

export default function StoreCard({
  arrayCategory,
  setChildeValueCategory,
  setUpdatePercentage,
}: StoreCardProps) {
  const [editPercent, setEditPercent] = React.useState(false);
  const [getPercent, setGetPercent] = React.useState<number | null>();
  const editPercentage = () => {
    setEditPercent(!editPercent);
  };
  const savePercentage = () => {
    setEditPercent(!editPercent);
    arrayCategory.SettlementPercentage = getPercent!;
    setUpdatePercentage(arrayCategory);
  };
  const changeValuePercentage = (e: any) => {
    if (e.target.value <= 99) {
      if (e.target.value === "") {
        setGetPercent(null);
      } else {
        setGetPercent(e.target.value);
      }
    }
  };
  const deleteCard = () => {
    setChildeValueCategory(arrayCategory);
  };
  useEffect(() => {
    setGetPercent(arrayCategory?.SettlementPercentage);
  }, []);
  useEffect(() => {
    setGetPercent(arrayCategory?.SettlementPercentage);
  }, [arrayCategory?.SettlementPercentage]);
  return (
    <div
      style={{
        backgroundColor: "#1B3045",
        borderRadius: "5px",
        height: "10vh",
        width: "30vh",
        // marginRight: "1vh",
      }}
    >
      <Grid
        container
        style={{
          height: "100%",
        }}
      >
        <Grid
          xs={3}
          style={{
            textAlign: "center",
            alignContent: "center",
          }}
        >
          <img
            src={`data:image/png;base64,${arrayCategory?.icon}`}
            alt={arrayCategory?.title || "Category Icon"}
            style={{
              width: "6vh",
              height: "6vh",
              borderRadius: "50%",
              backgroundColor: "#fff",
            }}
          />
        </Grid>
        <Grid
          xs={6}
          style={{
            color: "#fff",
            textAlign: "right",
            alignContent: "center",
            paddingRight: "0.2vh",
          }}
        >
          <p style={{ fontSize: "1rem", fontWeight: "bold" }}>
            {arrayCategory?.title!}
          </p>
          {editPercent ? (
            <div
              style={{
                maxWidth: "6vh",
              }}
            >
              <MaterialTextFieldComponent
                className="shadowTextFieldStoreCard"
                helperText={""}
                placeHolder={""}
                label={""}
                required={false}
                value={getPercent}
                onChange={changeValuePercentage}
                name="settlementPercentage"
                id="settlementPercentage"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "2.6vh !important",
                  },
                }}
              />
            </div>
          ) : (
            <p
              style={{
                fontSize: "12px",
                marginBottom: "0px",
              }}
            >
              درصد تسـویه
              {getPercent ? (
                <span style={{ marginRight: "0.5vh" }}>{getPercent}%</span>
              ) : (
                <span style={{ marginRight: "0.5vh" }}>--</span>
              )}
            </p>
          )}
        </Grid>
        <Grid
          xs={3}
          style={{
            color: "#fff",
            textAlign: "center",
            alignContent: "end",
          }}
        >
          {editPercent ? (
            <Button
              style={{ maxWidth: "7px", minWidth: "5px", color: "#fff" }}
              onClick={savePercentage}
            >
              <CheckOutlinedIcon
                style={{
                  marginBottom: "1vh",
                  marginLeft: "1.5vh",
                  width: "2.4vh",
                  height: "2.4vh",
                }}
              />
            </Button>
          ) : (
            <Button
              style={{ maxWidth: "7px", minWidth: "5px", color: "#fff" }}
              onClick={editPercentage}
            >
              <EditOutlinedIcon
                style={{
                  marginBottom: "1vh",
                  marginLeft: "1.5vh",
                  width: "2.4vh",
                  height: "2.4vh",
                }}
              />
            </Button>
          )}
          <Button
            style={{ maxWidth: "7px", minWidth: "5px", color: "#fff" }}
            onClick={deleteCard}
          >
            <CloseIcon
              style={{
                marginBottom: "1vh",
                width: "2vh",
                height: "2vh",
              }}
            />
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
